import React from 'react';

// eslint-disable-next-line no-shadow
export enum NavigationLink {
  Home,
  Cards,
  Commands,
  Compliance,
  Requests,
  Performance,
  Settings,
  Sessions,
}

const BlackListLinkContext = React.createContext({
  links: [],
  // eslint-disable-next-line @typescript-eslint/no-unused-vars, no-unused-vars
  addLink: (link: NavigationLink) => { },
  // eslint-disable-next-line @typescript-eslint/no-unused-vars, no-unused-vars
  removeLink: (link: NavigationLink) => { },
});

export default BlackListLinkContext;
